(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scField/scErrorField/template', '<div\n' + '  class="form_error form_inset-error"\n' + '  data-ng-show="{{condition}}"\n' + '  qa-id="{{ bind(\'scQaId.errorMessage\') }}"\n' + '  _spec="error-message"\n' + '>\n' + '  {{message}}\n' + '</div>\n' + '');
}]);
})();